import { Badge } from "@/components/base/badges/badges";
import type { MailboxConnectionStatus } from "@/types/api/admin";

interface ConnectionStatusBadgeProps {
    status: MailboxConnectionStatus;
}

const STATUS_CONFIG: Record<MailboxConnectionStatus, { color: "success" | "warning" | "error" | "gray"; label: string }> = {
    Connected: { color: "success", label: "Connected" },
    TokenExpired: { color: "warning", label: "Token Expired" },
    Error: { color: "error", label: "Error" },
    Disconnected: { color: "gray", label: "Disconnected" },
};

export function ConnectionStatusBadge({ status }: ConnectionStatusBadgeProps) {
    const config = STATUS_CONFIG[status] ?? STATUS_CONFIG.Disconnected;
    return (
        <Badge color={config.color} size="sm" type="pill-color">
            {config.label}
        </Badge>
    );
}
